// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import * as tslib_1 from "tslib"; // THIS FILE WAS AUTOGENERATED

import { Domain } from './Domain';
/**
 * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
 */

var MetricData =
/** @class */
function (_super) {
  tslib_1.__extends(MetricData, _super);

  function MetricData() {
    var _this = _super.call(this) || this;

    _this.ver = 2;
    _this.metrics = [];
    _this.properties = {};
    return _this;
  }

  return MetricData;
}(Domain);

export { MetricData };